import Coin3D from './Coin3D';

export default function LoadingOverlay({ isOpen, label }) {
  if (!isOpen) return null;
  return (
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-overlay-content">
        <div className="loading-overlay-logo">
          <Coin3D size={160} gold={false} imageUrl="/logo-cogency.png" />
        </div>
        {label && <span className="loading-overlay-label">{label}</span>}
      </div>
    </div>
  );
}
